export default __webpack_public_path__ + "static/media/K_Kuara.0c9a3193.svg";